"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = require("react");
var useToggler = function useToggler(defaultIsOpen) {
  var _useState = (0, _react.useState)(defaultIsOpen || false),
    isOpen = _useState[0],
    setIsOpen = _useState[1];
  var setClose = (0, _react.useCallback)(function () {
    return setIsOpen(false);
  }, []);
  var setOpen = (0, _react.useCallback)(function () {
    return setIsOpen(true);
  }, []);
  var setToggle = function setToggle() {
    return setIsOpen(!isOpen);
  };
  return {
    isOpen: isOpen,
    setOpen: setOpen,
    setClose: setClose,
    setToggle: setToggle
  };
};
var _default = exports.default = useToggler;